const createVoucherEN = {
    key: 'Key',
    productId: 'Product ID',
    variantId: 'Variant ID',
    licenseId: 'License ID',
    maxSessions: 'Max Uses',
    generate: 'Generate Key'
}

export default createVoucherEN